import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from '../../providers/user';
import { Preferences } from "@capacitor/preferences";
@Injectable()
export class AuthGuard implements CanActivate {
  // public user: { mobile: "" };
  constructor(private router: Router, private user: UserService) { }

  canActivate() {
    // localStorage.setItem('id_token', "");
    // let user = JSON.parse(window.localStorage.getItem('webUser'));
    // // console.log(user, "inside guard");
    if (this.user && this.user.mobile && this.user.mobile != null && this.user.mobile != undefined && this.user.mobile.toString().length >= 10) {
      return true;
    } else {
      this.router.navigate(['/auth']);
      return false;
    }
  }
}